import React from 'react';
import { Package, FileText, Download } from 'lucide-react';
import { products } from '../data/mock';

const Prodotti = () => {
  return (
    <div className="prodotti-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-title">I Nostri <span className="text-brand-orange">Prodotti</span></h1>
          <div className="accent-line"></div>
          <p className="body-large text-secondary" style={{ maxWidth: '800px', marginTop: '1.5rem' }}>
            Forniamo prodotti di alta qualità certificati per la segnaletica stradale e industriale
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="section">
        <div className="container">
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card card">
                <div className="product-image">
                  {product.image === 'placeholder' ? (
                    <div className="product-placeholder">
                      <Package size={64} />
                      <p>Foto in arrivo</p>
                    </div>
                  ) : (
                    <img src={product.image} alt={product.name} />
                  )}
                </div>
                <div className="product-info">
                  <p className="product-category">{product.category}</p>
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            ))}
          </div>

          {products.length === 0 && (
            <div className="no-products">
              <Package size={80} className="no-products-icon" />
              <p className="body-large text-secondary">
                I prodotti saranno disponibili a breve
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Catalog Download */}
      <section className="catalog-section" data-testid="catalog-download-section">
        <div className="container">
          <div className="catalog-card">
            <div className="catalog-icon-wrap">
              <FileText size={56} />
            </div>
            <div className="catalog-content">
              <p className="catalog-eyebrow">Catalogo Completo</p>
              <h2 className="catalog-title">
                Scopri <span className="text-brand-orange">tutti i prodotti</span> che forniamo
              </h2>
              <p className="catalog-desc">
                Sfoglia il catalogo ufficiale SI.SA. LINE: troverai l'intera gamma di segnaletica
                stradale, dispositivi di sicurezza e prodotti industriali certificati che mettiamo
                a disposizione dei nostri clienti.
              </p>
              <a
                href="/catalogo-sisaline.pdf"
                download="Catalogo-SISALINE.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="catalog-btn"
                data-testid="catalog-download-btn"
              >
                <Download size={20} />
                <span>Scarica il catalogo (PDF)</span>
                <span className="catalog-size">6.1 MB</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .prodotti-page {
          padding-top: 80px;
        }

        .page-hero {
          padding: var(--space-xl) 0 var(--space-lg);
          background: var(--bg-page);
        }

        /* Products Grid */
        .products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
        }

        @media (max-width: 1024px) {
          .products-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .products-grid {
            grid-template-columns: 1fr;
          }
        }

        .product-card {
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .product-image {
          width: 100%;
          height: 280px;
          overflow: hidden;
          background: var(--bg-card-hover);
        }

        .product-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .product-card:hover .product-image img {
          transform: scale(1.05);
        }

        .product-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: var(--text-muted);
          gap: 1rem;
        }

        .product-info {
          padding: var(--space-md);
        }

        .product-category {
          color: var(--brand-orange);
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 0.5rem;
        }

        .product-name {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.75rem;
        }

        .product-description {
          color: var(--text-secondary);
          line-height: 1.6;
        }

        /* No Products */
        .no-products {
          text-align: center;
          padding: var(--space-xl) 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.5rem;
        }

        .no-products-icon {
          color: var(--brand-blue);
          opacity: 0.3;
        }

        /* Catalog Download Section */
        .catalog-section {
          padding: var(--space-lg) 0 var(--space-xl);
        }

        .catalog-card {
          display: flex;
          align-items: center;
          gap: 2.5rem;
          padding: 3rem;
          background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
          border: 1px solid rgba(234, 88, 12, 0.15);
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(234, 88, 12, 0.08);
        }

        .catalog-icon-wrap {
          flex-shrink: 0;
          width: 110px;
          height: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--brand-orange);
          color: white;
          border-radius: 20px;
          box-shadow: 0 8px 24px rgba(234, 88, 12, 0.25);
        }

        .catalog-content {
          flex: 1;
        }

        .catalog-eyebrow {
          color: var(--brand-orange);
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          margin-bottom: 0.5rem;
        }

        .catalog-title {
          font-size: 2rem;
          font-weight: 700;
          color: var(--text-primary);
          line-height: 1.2;
          margin-bottom: 1rem;
        }

        .catalog-desc {
          color: var(--text-secondary);
          font-size: 1.05rem;
          line-height: 1.6;
          margin-bottom: 1.75rem;
          max-width: 640px;
        }

        .catalog-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem 1.75rem;
          background: var(--brand-orange);
          color: white;
          font-weight: 600;
          font-size: 1rem;
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.25s ease;
          box-shadow: 0 6px 20px rgba(234, 88, 12, 0.3);
        }

        .catalog-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 28px rgba(234, 88, 12, 0.4);
          background: #c2410c;
        }

        .catalog-size {
          padding: 0.25rem 0.6rem;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 6px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .catalog-card {
            flex-direction: column;
            text-align: center;
            padding: 2rem 1.5rem;
            gap: 1.5rem;
          }

          .catalog-icon-wrap {
            width: 90px;
            height: 90px;
          }

          .catalog-title {
            font-size: 1.5rem;
          }

          .catalog-desc {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Prodotti;
